import classNames from 'classnames';
import { createElement } from 'react';

var Tab = function (props) {
    var active = props.active, children = props.children, className = props.className, href = props.href, value = props.value, onClick = props.onClick;
    return (createElement("li", { className: classNames('RUITab', className) },
        createElement("a", { className: classNames('RUITab_Button', { active: active }), href: href, onClick: function (e) { return onClick(e, value); } }, children)));
};
var Tabs = function (props) {
    var _a = props.activeColor, activeColor = _a === void 0 ? 'black' : _a, children = props.children, className = props.className, flex = props.flex;
    return (createElement("ul", { className: classNames('RUITabs', "RUITabs-activeColor-" + activeColor, { 'RUITabs-flex': flex }, className) }, children));
};

export { Tab, Tabs };
//# sourceMappingURL=Tabs.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/Tabs.js